import * as angular from "angular";
import * as _ from "lodash";

angular
  .module('bringoz.admin.commons')
  .directive('timeStringModel', timeStringModel);

function timeStringModel() {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: (scope, element, attrs, ngModel) => {

      // Model → View (string "12:10" → Date)
      ngModel.$formatters.push(function(modelValue) {
        if (!modelValue) return null;

        if (_.isDate(modelValue)) {
          return modelValue;
        }

        // Expecting "HH:mm"
        var parts = modelValue.split(':');
        if (parts.length !== 2) return null;

        var d = new Date();
        d.setHours(parseInt(parts[0], 10));
        d.setMinutes(parseInt(parts[1], 10));
        d.setSeconds(0);
        d.setMilliseconds(0);

        return d;
      });

    }
  };
}
